import React from 'react';
import BaseComponent from './BaseComponent';
import Event from './Event';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import classNames from 'classnames';
import {List, ListItem, ListBody, ListTitle, ListContent} from './UIList';

export class PureVenueList extends BaseComponent {
    render() {
        const {venues, selectedVenueID} = this.props;

        return <div className="venue-list">
            <List>
                {venues.toList().sortBy(v => v.name).map(venue => {
                    const path = `/venue/${venue.id}`;
                    const active = 'venue' && selectedVenueID === venue.id;
                    return <ListItem active={active} key={venue.id} to={path}>
                        <ListBody>
                            <ListTitle>{venue.name}</ListTitle>
                            <ListContent>{venue.description}</ListContent>
                        </ListBody>
                    </ListItem>
                })}
            </List>
        </div>;
    }
}

function mapStateToProps({app}) {
    return {venues: app.get('venues')};
}

export default connect(mapStateToProps)(PureVenueList);



/** WEBPACK FOOTER **
 ** ./src/components/VenueList.jsx
 **/